import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React, { useEffect } from "react";
import Loader from '../../../utils/Loader';
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddTaskDetailsMutation } from "../../../Services/api";
export default function CreateTaskDetails(props) {
    const notify = () => '';
    const validationSchema = Yup.object().shape({
        title: Yup.string().required("title fields is required"),
    });

    const [addTaskDetails, isLoading] = useAddTaskDetailsMutation();
    var defaultValues = {
        title: ''
    };
    const methods = useForm({
        mode: "onTouched",
        resolver: yupResolver(validationSchema),
        defaultValues: defaultValues,
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = methods;
    const updateCourseList = (values, e) => {
        const formData = new FormData();
        formData.append('title', values.title);
        formData.append('course_task_id', props['id']);
      
        addTaskDetails(formData)
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                    e.target.reset()
                    toast.success(payload.message)
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
        notify();
    };
    return (

        <div className="modal fade" id="fullscreenModalDetails">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Task Details</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <section className="section">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Add Task Details</h5>
                                    <form onSubmit={handleSubmit(updateCourseList)} >

                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Title</label>
                                            <div className="col-sm-10">
                                                <input type="name" {...register("title", { required: true })} className="form-control" />
                                                {errors.title && <span className="text-danger">title is required</span>}

                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            {isLoading.status !== 'pending' ?
                                                <>
                                                    <button type="submit" className="btn btn-warning">Save changes</button>
                                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                </>
                                                :
                                                <button type="submit" className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                            }
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}